module.exports = __webpack_public_path__ + "static/img/act-steps-pc-hk.c2a80b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/act-steps-pc-hk.png
// module id = eV9I
// module chunks = 1